import React from 'react';
import cn from 'classnames';

import { Cross as CloseIcon } from '@periodica/ui-kit/icons';

import { Paragraph as P } from '../../Paragraph';
import { MapPin, Clock, Certificate } from '../../../icons';
import type { PaymentMethod } from '../types';

import styles from './Balloon.module.scss';

interface BalloonArgs {
  provider: string;
  title: string;
  openingHours: string;
  howToGet: string;
  fullscreenMap: boolean;
  paymentMethods: PaymentMethod[];
  onClose: () => void;
}

const humanizePaymentMethods = (paymentMethods: PaymentMethod[]) => {
  if (paymentMethods.length === 1 && paymentMethods.includes('online')) {
    return 'Только предоплата';
  }
  if (paymentMethods.length === 1 && paymentMethods.includes('cash')) {
    return 'Оплата только при получении';
  }
  return 'Оплата при получении возможна';
};

export function Balloon({
  provider,
  title,
  openingHours,
  howToGet,
  fullscreenMap,
  paymentMethods,
  onClose,
}: BalloonArgs) {
  return (
    <div
      className={cn({
        [styles.balloonMain]: true,
        [styles.fullBalloon]: fullscreenMap,
      })}
    >
      <div className={styles.metadata}>
        <P size="large" weight="emphasized">
          {provider}
        </P>
        <div className={styles.infoBlock}>
          <div className={styles.infoLine}>
            <MapPin />
            <P>{title}</P>
          </div>
          {!!openingHours && (
            <div className={styles.infoLine}>
              <Clock />
              <P>{openingHours}</P>
            </div>
          )}
          <div className={styles.infoLine}>
            <Certificate />
            <P>{humanizePaymentMethods(paymentMethods)}</P>
          </div>
        </div>
        {howToGet && (
          <div className={styles.route}>
            <P size="small" color="secondary">
              Как добраться
            </P>
            <P className={styles.mainRoute}>{howToGet}</P>
          </div>
        )}
      </div>
      <button className={styles.closeButtonContainer} onClick={onClose} type="button">
        <div className={styles.closeButton}>
          <CloseIcon color="white" />
        </div>
      </button>
    </div>
  );
}
